import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const CurrencyName = ({ currency }) => {
  if (!currency) {
    return <span />;
  }

  switch (currency) {
    case 'eur':
      return <FormattedMessage defaultMessage="EUR €" />;
    case 'usd':
      return <FormattedMessage defaultMessage="USD $" />;
    default:
      return <span>{currency}</span>;
  }
};

CurrencyName.propTypes = {
  currency: PropTypes.string,
};

export default CurrencyName;
